import { useRef, useEffect } from 'react';
import { BufferGeometry } from 'three';
import { SimplifyModifier } from 'three/examples/jsm/modifiers/SimplifyModifier';

function useSimplification(simplePercent) {
  const ref = useRef();
  const original = useRef();
  const modifier = useRef();
  useEffect(() => {
    if (!original.current) {
      original.current = ref.current.geometry.clone();
      modifier.current = new SimplifyModifier();
    }
  }, []);
  useEffect(() => {
    if (original.current && ref.current) {
      let geometry = new BufferGeometry();
      geometry = original.current.clone();
      const count = Math.floor(geometry.attributes.position.count * simplePercent); // number of vertices to remove

      ref.current.geometry = modifier.current.modify(geometry, count);
    }
  }, [simplePercent]);
  return ref;
}

export { useSimplification };
